module.exports = __webpack_public_path__ + "static/media/ClosingBalance.9aa3bc50.svg";